// src/components/Layout.js
import React from 'react';
import Header from './Header';
import { Outlet , useLocation } from 'react-router-dom';
import NavigationBar from './NavigationBar';
import { Toolbar } from '@mui/material';
const Layout = ({ children }) => {

  const location = useLocation();
  // 공사현황 url로 접속되면 네비게이션바 적용하지 않음
  const showNavigationBar = location.pathname !== '/' && location.pathname !== '/construction';

  return (
    <div style={{ backgroundColor: '#f0f0f0', minHeight: '100vh' }}>
      <Header />
      <Toolbar />
      
      <main style={{ minHeight: '80vh', padding: '20px', paddingTop: '40px'}}>
        <div style={{ display : 'flex', width: '100%', maxWidth: showNavigationBar? '80%' : '100%', margin : 'auto'}}>
          <NavigationBar />
          <div style = {{ flex: 1, marginLeft: showNavigationBar? '20px' : '0px', maxWidth: '100%', minWidth: 400}}>
            <Outlet/>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Layout;
